"use client";
import { u as a } from "./index43.js";
import o from "./index44.js";
import * as m from "react";
import { forwardRef as f } from "react";
import { S as s } from "./index45.js";
import { c as v, d as x } from "./index45.js";
import "react-dom";
var c = /* @__PURE__ */ f(function(e, t) {
  var r = a(e);
  return /* @__PURE__ */ m.createElement(s, o({
    ref: t
  }, r));
}), d = c;
export {
  v as createFilter,
  d as default,
  x as defaultTheme,
  a as useStateManager
};
